<template>
  <div
    :key="generateId(schema.model)"
    :id="generateId(schema.model)"
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['d-flex', getSelectedDEV && 'dev-selected-component']"
  >
    <vue-editor v-model="htmlForEditor" v-bind="schema.attributes"></vue-editor>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import { VueEditor } from 'vue2-editor';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, componentMixin],

  mounted() {
    this.htmlForEditor = this.value;
  },

  watch: {
    htmlForEditor(newValue) {
      this.value = newValue;
    }
  },

  components: {
    VueEditor
  },

  data() {
    return {
      htmlForEditor: null,
      htmlSaved: null
    };
  }
};
</script>
